// src/AssistantCloudAuthTokens.tsx
var AssistantCloudAuthTokens = class {
  constructor(cloud) {
    this.cloud = cloud;
  }
  async create() {
    return this.cloud.makeRequest("/auth/tokens", { method: "POST" });
  }
};
export {
  AssistantCloudAuthTokens
};
//# sourceMappingURL=AssistantCloudAuthTokens.js.map